export function closeDropdownFromElementWithin(element: HTMLElement) {
  let parent = element.parentElement;

  while (parent && parent.tagName !== 'DETAILS') {
    parent = parent.parentElement;
  }

  if (parent) (parent as HTMLDetailsElement).open = false;
}
